<template>
    <div>
        <div
            ref="collapsibles"
            id="accordion_sessions"
            class="lb-accordion pb-6"
        >
            <article
                class="message"
            >
                <div class="message-header has-text-black">
                    <a
                        href="#session_active"
                        :ref="'session_active'"
                        data-action="collapse"
                        style="width: 100%"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="ml-2 mt-1">
                                                {{ $t('game_session_active') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="session_active"
                    class="message-body is-collapsible"
                    data-parent="accordion_sessions"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4" v-if="activeSession._id">
                        <div
                            class="
                                columns
                                is-mobile is-centered
                                py-0
                                is-vcentered
                            "
                        >
                            <div class="column is-6 py-0">
                                <figure class="image is-square">
                                    <vue-qrcode
                                        ref="qrcode"
                                        :value="
                                            shareSessionURL(activeSession.shortCode)
                                        "
                                    />
                                </figure>
                            </div>
                            <div class="column is-6 py-0">
                                <p class="is-size-6 has-text-centered">
                                    {{ $t('Sessions.code') }}
                                </p>
                                <p
                                    class="
                                        is-size-4
                                        has-text-centered has-text-weight-bold
                                        mb-2
                                    "
                                >
                                    {{ activeSession.shortCode }}
                                </p>

                                <p class="is-size-6 has-text-centered">
                                    {{ $t('Sessions.participants_count') }}
                                </p>
                                <p
                                    class="
                                        is-size-4
                                        has-text-centered has-text-weight-bold
                                    "
                                >
                                    {{
                                        activeSession.participants
                                            ? activeSession.participants.length
                                            : 0
                                    }}
                                </p>
                            </div>
                        </div>

                        <hr />
                        <router-link
                            :to="{
                                name: 'session-detail',
                                params: { _id: activeSession._id },
                            }"
                            target="_blank"
                            ><button
                                class="
                                    button
                                    is-success is-uppercase
                                    has-text-weight-bold
                                    is-fullwidth is-size-6 is-radiusless
                                "
                                style="height: 100%"
                                v-t="'Sessions.stats'"
                        /></router-link>
                        <hr />
                        <form class="mb-4">
                            <div v-if="isRunningSession" class="mb-4">
                                <div class="notification is-warning" v-html="$t('game_session_no_session_edition')"/>
                            </div>
                            <div class="columns is-mobile is-vcentered is-multiline">

                                <!-- Device section -->
                                <div class="column is-12">
                                    <label
                                        v-t="'Sessions.play_mode_select'"
                                        for="appmode"
                                        class="label has-text-black"
                                    ></label>
                                    <div class="level is-mobile mb-2">
                                        <div class="level-item mr-0">
                                            <span
                                                ref="appButton"
                                                class="
                                                    button
                                                    is-light is-fullwidth
                                                    has-tooltip-bottom has-tooltip-multiline
                                                "
                                                :data-tooltip="
                                                    $t(`Sessions.play_mode_select_app`)
                                                "
                                                :class="{
                                                    'is-primary': isApp,
                                                }"
                                                @click.stop="setApp"
                                            >
                                                <span class="icon is-small">
                                                    <i
                                                        class="
                                                            mdi
                                                            mdi-18px
                                                            mdi-tablet-cellphone
                                                        "
                                                    ></i>
                                                </span>
                                                <span>APP</span>
                                            </span>
                                        </div>
                                        <div class="level-item mr-0">
                                            <span
                                                ref="webButton"
                                                class="
                                                    button
                                                    is-light is-fullwidth
                                                    has-tooltip-bottom has-tooltip-multiline
                                                "
                                                :class="{
                                                    'is-primary': isWeb,
                                                }"
                                                :data-tooltip="
                                                    $t(`Sessions.play_mode_select_web`)
                                                "
                                                @click.stop="setWeb"
                                            >
                                                <span class="icon is-small">
                                                    <i class="mdi mdi-18px mdi-laptop"></i>
                                                </span>
                                                <span>WEB</span>
                                            </span>
                                        </div>
                                    </div>

                                    <label
                                        v-if="activeSession.configuration.app"
                                        v-t="'Sessions.play_mode_select_app_hint'"
                                        for="appmode"
                                        class="label is-italic"
                                    ></label>
                                    <label
                                        v-else
                                        v-t="'Sessions.play_mode_select_web_hint'"
                                        for="appmode"
                                        class="label is-italic"
                                    ></label>
                                </div>

                                <!-- Allow reset section -->
                                <label
                                    v-t="'game_session_user_behaivour'"
                                    class="label has-text-black px-4 column is-12 pb-0" 
                                ></label>

                                <div class="column is-6 pr-0 pl-4 pt-0">
                                    <p
                                        ref="canResetButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        @click.stop="setResetOn"
                                        :class="{
                                            'is-primary': activeSession.allowsReset==true,
                                        }"
                                    >
                                        {{$t(`game_session_user_can_reset`)}}
                                    </p>
                                </div>
                                <div class="column is-6 pl-0 pr-4 pt-0">
                                    <p
                                        ref="preventResetButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        @click.stop="setResetOff"
                                        :class="{
                                            'is-primary': activeSession.allowsReset==false,
                                        }"
                                    >
                                        {{$t(`game_session_user_prevent_reset`)}}
                                    </p>
                                </div>

                                <label
                                    v-if="activeSession.allowsReset"
                                    v-t="'game_session_user_can_reset_desc'"
                                    class="label is-italic pl-4"
                                ></label>
                                <label
                                    v-else
                                    v-t="'game_session_user_prevent_reset_desc'"
                                    for="appmode"
                                    class="label is-italic pl-4"
                                ></label>


                                <!-- Closer section -->
                                <label v-if="isModeMap && isTrivial"
                                    v-t="'game_session_questions_behaivour'"
                                    class="label has-text-black px-4 column is-12 pb-0" 
                                ></label>
                                    
                                <div v-if="isModeMap && isTrivial" class="column is-6 pr-0 pl-4 pt-0">
                                    <p
                                        ref="closerButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        @click.stop="setCloserOn"
                                        :class="{
                                            'is-primary': activeSession.configuration.closer==true,
                                        }"
                                    >
                                        {{$t(`game_session_question_closer`)}}
                                    </p>
                                </div>
                                <div v-if="isModeMap && isTrivial" class="column is-6 pl-0 pr-4 pt-0">
                                    <p
                                        ref="chosingButton"
                                        class="
                                            button
                                            is-light is-multiline is-fullwidth
                                        "
                                        @click.stop="setCloserOff"
                                        :class="{
                                            'is-primary': activeSession.configuration.closer==false,
                                        }"
                                    >
                                        {{$t(`game_session_question_choose`)}}
                                    </p>
                                </div>
                                <label
                                    v-if="activeSession.configuration.closer"
                                    v-t="'game_session_question_closer_desc'"
                                    class="label is-italic pl-4"
                                ></label>
                                <label
                                    v-else
                                    v-t="'game_session_question_choose_desc'"
                                    for="appmode"
                                    class="label is-italic pl-4"
                                ></label>

                                <!-- Feedback section -->
                                <div class="column is-12" v-if="isTrivial">
                                    <div class="field">
                                        <label
                                            v-t="'Sessions.show_at_end'"
                                            class="label has-text-black"
                                        ></label>
                                        <div class="control is-expanded">
                                            <textarea
                                                rows="3"
                                                v-model="activeSession.configuration.feedback"
                                                :placeholder="$t('Sessions.end_of_game_info')"
                                                class="textarea has-fixed-size"
                                                :disabled="isRunningSession"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <label
                                        v-t="'game_session_end_text_desc'"
                                        class="label is-italic"
                                    ></label>
                                </div>
                            </div>
                        </form>

                        
                    </div>
                    <div v-else class="message-body-content px-4 py-4">
                        <div class="notification is-warning" v-html="$t('game_session_no_active_session')"/>
                    </div>
                </div>
            </article>

            <article
                class="message"
            >
                <div class="message-header has-text-black">
                    <a
                        href="#session_list"
                        :ref="'session_list'"
                        data-action="collapse"
                        style="width: 100%"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="ml-2 mt-1">
                                                {{ $t('game_session_list') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="session_list"
                    class="message-body is-collapsible"
                    data-parent="accordion_sessions"
                    data-allow-multiple="false"
                >
                    
                    <div class="message-body-content px-0 py-0">
                        <l-project-sessions-list />
                    </div>
                </div>
            </article>

            <article v-if="project.type!='treasurehunt'"
                class="message"
            >
                <div class="message-header has-text-black">
                    <a
                        href="#session_simulation"
                        :ref="'session_simulation'"
                        data-action="collapse"
                        style="width: 100%"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="ml-2 mt-1">
                                                {{ $t('game_session_simulation') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="session_simulation"
                    class="message-body is-collapsible"
                    data-parent="accordion_sessions"
                    data-allow-multiple="false"
                >
                    
                    <div class="message-body-content px-4 py-4">
                        <div class="notification is-primary is-light" v-html="$t('game_session_start_simulation_desc')"/>
                        <div class="has-text-centered">
                            <button @click="$emit('start-simulation')" class="button is-success is-centered">{{$t('game_session_start_simulation')}}</button>
                        </div>
                    </div>
                </div>
            </article>


        </div>
        <!--<button @click="$emit('start-simulation')" class="button is-success bottom-full-button">{{$t('game_session_start_simulation')}}</button>-->
    </div>
</template>

<script>
import { fetchItems, updateItem } from '@/services/API';
import _ from 'underscore';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import moment from 'moment';
import VueQrcode from 'vue-qrcode';
import LProjectSessionsList from '@/components/LProjectSessionsList';
export default {
    components: {
        VueQrcode,
        LProjectSessionsList
    },
    props: {
        activeSession: { type: Object, default: {} },
    },
    data() {
        return { sessions: [], session: {} };
    },
    filters: {
        createdDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    computed: {
        project() {
            return this.$store.getters.project;
        },
        editing() {
            // console.log(this.session, this.session._id);
            return this.session._id ? true : false;
        },

        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        hasActiveSession(){
            return this.activeSession.length;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map';
        },
        isWeb() {
            // console.log('isWeb', this.session.configuration.web === true);
            return (
                this.activeSession.configuration.web &&
                !this.activeSession.configuration.app
            );
        },
        isApp() {
            // console.log('isApp', this.session.configuration.app === true);
            return (
                this.activeSession.configuration.app &&
                !this.activeSession.configuration.web
            );
        },
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
        isRunningSession(){
            return this.activeSession.isActive&&!this.activeSession.isPaused;
        }
    },
    async mounted() {
       
        this.$nextTick(() => {
            const collapsibles = bulmaCollapsible.attach();
            // console.log(this.activeSession._id)
        });
    },
    methods: {
        
        shareSessionURL(session) {
 

            return (
                process.env.VUE_APP_SHARE_SESSION_URL +
                session.shortCode +
                '&lang=' +
                this.$i18n.locale
            );
        },
        playType(session) {
            if (!session.configuration.app && !session.configuration.web) {
                return 'ALL';
            } else if (session.configuration.web) {
                return 'WEB';
            } else if (session.configuration.app) {
                return 'APP';
            }

            return 'ALL';
        },
        setCloserOn() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.closer = true;
        },
        setCloserOff() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.closer = false;
        },
        setResetOn() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.allowsReset = true;
        },
        setResetOff() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.allowsReset = false;
        },
        setWeb() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.app = false;
            this.activeSession.configuration.web = true;
        },
        setApp() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.app = true;
            this.activeSession.configuration.web = false;
        },
        
    },
};
</script>

<style scoped>
@import '../assets/css/leftPanel.css';
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
}
.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}
.lb-accordion {
    overflow-y: auto;
    max-height: calc(100vh - 13rem);
    overflow-x: hidden;
}
.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body.is-collapsible {
    overflow-x: hidden;
}

.button.is-multiline {
  min-height: 2.25em;
  white-space: unset;
  height: auto;
  flex-direction: column;
}

.bottom-full-button{
    position: absolute;
    bottom: 0;
    border-radius: 0px;
    width: 100%;
}
</style>
